import { render, staticRenderFns } from "./ReferralLink.vue?vue&type=template&id=35c7b628&scoped=true&"
import script from "./ReferralLink.vue?vue&type=script&lang=js&"
export * from "./ReferralLink.vue?vue&type=script&lang=js&"
import style0 from "./ReferralLink.vue?vue&type=style&index=0&id=35c7b628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7b628",
  null
  
)

export default component.exports